import { Action, Selector, State, StateContext } from '@ngxs/store';
import { ShipmentLoadTransportOrderModel } from '../../models';
import { NotificationService } from '../../../../../common/services';
import { CustomHttpErrorResponse, Error } from '../../../../../common/constants';
import { Observable, of } from 'rxjs';
import { ShipmentLoadTransportOrdersService } from './shipment-load-transport-orders.service';
import {
  ShipmentLoadTransportOrdersInitialState,
  ShipmentLoadTransportOrdersLoad,
} from './shipment-load-transport-orders.actions';
import { catchError, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export interface ShipmentLoadTransportOrdersStateModel {
  transportOrders: ShipmentLoadTransportOrderModel[];
  loaded: boolean;
}

const initialState: ShipmentLoadTransportOrdersStateModel = {
  transportOrders: [],
  loaded: false,
};

@State<ShipmentLoadTransportOrdersStateModel>({
  name: 'shipmentLoadTransportOrders',
  defaults: initialState,
})
@Injectable()
export class ShipmentLoadTransportOrdersState {
  @Selector()
  static getState(state: ShipmentLoadTransportOrdersStateModel): ShipmentLoadTransportOrdersStateModel {
    return state;
  }

  @Selector()
  static getLoaded(state: ShipmentLoadTransportOrdersStateModel): boolean {
    return state.loaded;
  }

  @Selector()
  static getTransportOrders(state: ShipmentLoadTransportOrdersStateModel): ShipmentLoadTransportOrderModel[] {
    return state.transportOrders;
  }

  constructor(
    private shipmentLoadTransportOrdersService: ShipmentLoadTransportOrdersService,
    private notificationService: NotificationService,
  ) {}

  @Action(ShipmentLoadTransportOrdersLoad)
  getShipmentLoadTransportOrders(
    ctx: StateContext<ShipmentLoadTransportOrdersStateModel>,
    { payload }: ShipmentLoadTransportOrdersLoad,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.shipmentLoadTransportOrdersService.getShipmentLoadTransportOrders(payload).pipe(
      map((transportOrders: ShipmentLoadTransportOrderModel[]) => {
        ctx.patchState({ transportOrders, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(ShipmentLoadTransportOrdersInitialState)
  setInitialState(ctx: StateContext<ShipmentLoadTransportOrdersStateModel>): void {
    ctx.setState(initialState);
  }
}
